"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAdjacentStacks = exports.doShareEdge = exports.getAdjacentItem = void 0;
const getAdjacentItem = (component, edge) => {
    const { parent } = component;
    if (parent.isRoot) {
        return undefined;
    }
    const targetType = ['top', 'bottom'].includes(edge) ? 'column' : 'row';
    const edgeSiblingOffset = ['top', 'left'].includes(edge) ? -1 : 1;
    if (parent.type === targetType) {
        const componentIndex = parent.contentItems.indexOf(component);
        const targetIndex = componentIndex + edgeSiblingOffset;
        if (targetIndex >= 0 && targetIndex < parent.contentItems.length) {
            return parent.contentItems[targetIndex];
        }
    }
    return (0, exports.getAdjacentItem)(parent, edge);
};
exports.getAdjacentItem = getAdjacentItem;
const doShareEdge = (from, to, edge) => {
    var _a, _b;
    const boundsFrom = (_a = from.element.get(0)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    const boundsTo = (_b = to.element.get(0)) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
    if (!boundsFrom || !boundsTo) {
        return false;
    }
    if (['top', 'bottom'].includes(edge)) {
        const horizontallyOutOfBounds = boundsFrom.right < boundsTo.left || boundsFrom.left > boundsTo.right;
        return !horizontallyOutOfBounds;
    }
    const verticallyOutOfBounds = boundsFrom.bottom < boundsTo.top || boundsFrom.top > boundsTo.bottom;
    return !verticallyOutOfBounds;
};
exports.doShareEdge = doShareEdge;
const getAdjacentStacks = (item, edge) => {
    const targetContainer = ['top', 'bottom'].includes(edge) ? 'row' : 'column';
    const findEdgeStacks = (component) => {
        if (component.type === 'stack') {
            if ((0, exports.doShareEdge)(item, component, edge)) {
                return [component];
            }
            return [];
        }
        if (component.type === 'root') {
            return [];
        }
        if (component.type === targetContainer) {
            return component.contentItems.map((contentItem) => findEdgeStacks(contentItem)).flat();
        }
        if (component.type !== targetContainer) {
            if (['top', 'right'].includes(edge)) {
                return findEdgeStacks(component.contentItems[component.contentItems.length - 1]);
            }
            return findEdgeStacks(component.contentItems[0]);
        }
        return [];
    };
    const edgeItem = (0, exports.getAdjacentItem)(item, edge);
    if (edgeItem) {
        return findEdgeStacks(edgeItem);
    }
    return [];
};
exports.getAdjacentStacks = getAdjacentStacks;
